<template>
    <v-stepper v-model="currentStep" class="estilo_pasos secondary lighten-4">
        <v-stepper-header>
            <v-stepper-step
                :complete="currentStep > 1"
                step="1"
            >
                Trámite a Pagar
            </v-stepper-step>

            <v-stepper-step
                :complete="currentStep > 2"
                step="2"
            >
                Datos Fiscales
            </v-stepper-step>

            <v-stepper-step
                :complete="currentStep > 3"
                step="3"
            >
                Proceso de pago
            </v-stepper-step>

            <v-stepper-step 
                :complete="currentStep > 4"
            step="4">
                Finalizado
            </v-stepper-step>

        </v-stepper-header>
    </v-stepper>
</template>

<script>
    export default {
        name: 'Portofoliosteps',
        props: ['currentStep']
    };
</script>

<style scoped>

    .v-stepper__header{
        justify-content: space-evenly !important;
        flex-wrap: nowrap;
    }

    .estilo_pasos{
        top: -22px;
        margin-left: -22px;
        margin-right: -22px;
        border-radius: 0px;
        box-shadow: none;
        background-color: #f6f1eb;
        }

    .estilo_pasos .v-stepper__header{
        height: auto;
        justify-content: center;
    }

    .estilo_pasos .v-stepper__step{
        padding: 10px 15px 10px 15px;
        width: 100%;
    }

    .estilo_pasos .v-stepper__step--active{
        background-color: #15212F;
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .v-stepper__step .v-stepper__step--complete{
        /* background-color: #ff8400 !important; */
    }

    .v-stepper__step--complete{
        background-color: #ff8400;
        
        
    }


    .estilo_pasos .v-stepper__step:after {
        content: "";
        position: absolute;
        z-index: 6;
        top: 0px;
        left: 100%;
        width: 0px;
        height: 0;
        border-left: 7px;
        border-top: 21px;
        border-bottom: 21px;
        border-style: solid;
        border-color: transparent transparent transparent #ff8400;
    }   
    
    


    .estilo_pasos .v-stepper__step--active:before {
        content: none;
    }

    
    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:after {
        content: "";
        position: absolute;
        z-index: 5;
        top: 0px;
        left: 101%;
        width: 0px;
        height: 0;
        border-left: 5px;
        border-top: 22px;
        border-bottom: 22px;
        border-style: solid;
        border-color: transparent transparent transparent #FFFFFF;
    }
    .estilo_pasos .v-stepper__step--complete ~ .v-stepper__step:after {
        /* border-color: transparent transparent transparent #ff8400; */
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step[data-v-12a7d700]:before{
        border-color: transparent transparent transparent #f6f1eb;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step[data-v-12a7d700]:after{
        /* border-color: transparent transparent transparent #f6f1eb !important; */
    }
    
    .v-stepper__step .v-stepper__step--inactive{
        border-color: transparent transparent transparent #f6f1eb !important;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:before {
        content: "";
        position: absolute;
        z-index: 6;
        top: 0px;
        left: 100%;
        width: 0px;
        height: 0;
        border-left: 5px;
        border-top: 22px;
        border-bottom: 22px;
        border-style: solid;
        border-color: transparent transparent transparent var(--v-secondary-lighten4);
    }
    
    .estilo_pasos .v-stepper__step--active:after{
        border-color: transparent transparent transparent #15212F;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:last-of-type:before {
        content: none;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:last-of-type:after {
        content: none;
    }

    .v-stepper__header{
        background-color: #f6f1eb;
    }
    .v-sheet.v-stepper:not(.v-sheet--outlined){
        box-shadow: none;
    }
</style>